import { Component } from '@angular/core';
import { ProgramType } from '@lsq-frontend/remote-services/all-java/financing-mk0-services';
import { ModalService } from '@lsq-frontend/common-ui';
import { ListRelationshipsForBulkEligibilityDto } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/model/list-relationships-for-bulk-eligibility-dto';

@Component({
    selector: 'bulk-action-confirmation-modal',
    styleUrls: ['./bulk-action-confirmation-modal.component.scss'],
    template: `
        <div>
            <p class="body">{{ confirmationText }}</p>
            <ng-container *ngIf="!!feeType && !!feeRate">
                <div class="fee-settings">
                    <div
                        [style.marginRight]="'5rem'"
                        [style.borderRight]="'1px solid #c6cdd7'"
                        [style.paddingRight]="'2rem'"
                    >
                        <p class="data-label">
                            Fee Type
                        </p>
                        <p class="header data-value-fee">
                            {{ feeType }}
                        </p>
                    </div>
                    <div [style.marginRight]="'5rem'">
                        <p class="data-label">
                            Fee Rate
                        </p>
                        <p class="header data-value-fee">
                            {{ feeRate }}
                        </p>
                    </div>
                </div>
            </ng-container>
            <data-card
                [style]="{
                    marginTop: '2rem',
                    display: 'block'
                }"
            >
                <div
                    [style]="{
                        maxHeight: '30rem',
                        overflowY: 'scroll'
                    }"
                >
                    <p class="label">Suppliers ({{ supplierNames.length }})</p>
                    <p class="body" *ngFor="let supplierName of supplierNames">
                        {{ supplierName }}
                    </p>
                </div>
            </data-card>
            <ng-container *ngIf="enrollmentNotificationEmails?.length > 0">
                <p
                    class="body"
                    [style]="{
                        marginTop: '2rem'
                    }"
                >
                    The following email accounts will also be notified the enrollment links were
                    sent out to the above suppliers.
                </p>
                <data-card
                    [style]="{
                        marginTop: '2rem',
                        display: 'block'
                    }"
                >
                    <div
                        [style]="{
                            maxHeight: '30rem',
                            overflowY: 'scroll'
                        }"
                    >
                        <p
                            class="body"
                            *ngFor="let enrollmentNotificationEmail of enrollmentNotificationEmails"
                        >
                            {{ enrollmentNotificationEmail }}
                        </p>
                    </div>
                </data-card>
            </ng-container>
        </div>
    `
})
export class BulkActionConfirmationModalComponent {
    public confirmationText: string;
    public supplierNames: string[];
    public feeType: ProgramType;
    public feeRate: string;
    public enrollmentNotificationEmails: string[];

    constructor(private _modalService: ModalService) {
        this.confirmationText = this._modalService.modal.data.confirmationText;
        const relationships: ListRelationshipsForBulkEligibilityDto[] = this._modalService.modal
            .data.relationships;

        this.supplierNames = this._buildSupplierStrings(relationships);
        this.feeType = this._modalService.modal.data.feeType;
        this.feeRate = this._modalService.modal.data.feeRate;
        this.enrollmentNotificationEmails = this._modalService.modal.data.enrollmentNotificationEmails;
    }

    // If a supplier only appears once in the list, we only show the supplier name.
    // If a supplier appears more than once, we want to append the buyer name in parentheses.
    private _buildSupplierStrings(
        relationships: ListRelationshipsForBulkEligibilityDto[]
    ): string[] {
        const supplierNames = relationships.map((rel) => rel.supplierName);

        // Got this from here https://stackoverflow.com/a/24968449
        const count = (names) => names.reduce((a, b) => ({ ...a, [b]: (a[b] || 0) + 1 }), {});
        const duplicates = (dict) => Object.keys(dict).filter((a) => dict[a] > 1);

        const duplicatedSuppliers = duplicates(count(supplierNames));

        return relationships.map((relationship) => {
            if (duplicatedSuppliers.includes(relationship.supplierName)) {
                return `${relationship.supplierName} (${relationship.buyerName})`;
            }
            return relationship.supplierName;
        });
    }
}
